export default __webpack_public_path__ + "5a2a0fcc7874cc1714d8fa0c70edf466.png";